export default __webpack_public_path__ + "static/media/animatedBlocks.399224c9.gif";